import React from 'react';
import { Link } from 'react-router-dom';

export default function BuildingConstruction() {
  return (
    <main>
      <div className="heading text-center py-8 bg-gray-100">
        <h3 className="text-4xl font-semibold">Building Construction</h3>
        <p className="text-gray-600">
          <Link to="/">home</Link> / Building Construction
        </p>
      </div>
      {/* Add your Building Construction page content here */}
    </main>
  );
}
